<div class="row m-0">
  <div class="col-12 card">
    <div class="card-header">
      <div class="row">
        <div class="col-12">
          <h1>{{ title }}</h1>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-lg-8 col-xl-6">
          <form [formGroup]="form">
            <div class="row">
              <div class="col-12">
                {{ 'required_fields_label' | translate }}
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <app-common-input
                  [form]="form"
                  [formValidationRequest$]="formValidationRequest$"
                  [context]="{
                    label: 'label_workspace_name',
                    field: $workspace.name,
                    overrideErrors: {
                      unique: 'form_error_unique_name' | translate,
                      maxlength: 'upsert_workspace_name_max_length_error_label' | translate: CHAR_LIMITS[$workspace.name],
                    },
                  }"
                >
                </app-common-input>
                <app-form-field-char-count [field]="form.get($workspace.name)" [charLimit]="CHAR_LIMITS[$workspace.name]">
                </app-form-field-char-count>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <app-common-textarea
                  [form]="form"
                  [formValidationRequest$]="formValidationRequest$"
                  [context]="{
                    label: 'description',
                    field: $workspace.description,
                    placeholder: '',
                  }"
                >
                </app-common-textarea>
                <app-form-field-char-count
                  [field]="form.get($workspace.description)"
                  [charLimit]="CHAR_LIMITS[$workspace.description]"
                ></app-form-field-char-count>
              </div>
            </div>

            <div class="row justify-content-between mt-4">
              <div class="col-auto">
                <a [routerLink]="[tenantRoutePath, tenantId]" id="cancelLink" class="btn btn-link text-underline">
                  {{ 'form_cancel' | translate }}
                </a>
              </div>
              <div class="col-auto">
                <button class="btn btn-lg btn-primary" type="submit" (click)="onSubmit()">
                  {{ submitButtonLabel }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
